import { Selection } from '@react-types/shared'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import Styles from './FiltersMenu.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowLeft } from 'blaze-ui/icons'
import { Tag } from 'common/OptionSelect/Tag'
import { StatusSelectProps } from './StatusMenu'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { compact } from 'lodash'

export enum PostStatusV2 {
  Draft = 'Draft',
  Scheduled = 'Scheduled',
  Review = 'Review',
  Approved = 'Approved',
  Failed = 'Failed',
  Posted = 'Posted',
}

export const STATUS_COLOR_FOR_STRATEGIES: Record<string, string> = {
  Draft: '#EAEDF1',
  Scheduled: '#fbe8b8',
  Posted: '#6a00ff1a',
  Failed: '#FDECEC',
  Posting: '#FFEFC5',
  Paused: '#EAEDF1',
  Approved: '#ECFDF3',
  Review: '#fbe8b8',
}

export const STATUS_FONT_COLOR_FOR_STRATEGIES: Record<string, string> = {
  Draft: '#344054',
  Scheduled: '#3f2b00',
  Posted: '#6a00ff',
  Failed: '#BC010B',
  Posting: '#D38E0F',
  Paused: '#344054',
  Approved: '#07942A',
  Review: '#3f2b00',
}

export const StatusMenuV2 = ({ selectedKeys, onChange, onBack }: StatusSelectProps) => {
  const workspace = useCurrentWorkspace()
  const approvalEnabled = workspace?.post_approval_enabled

  const statusItems: string[] = compact([
    PostStatusV2.Draft,
    !approvalEnabled ? PostStatusV2.Scheduled : undefined,
    approvalEnabled ? PostStatusV2.Review : undefined,
    approvalEnabled ? PostStatusV2.Approved : undefined,
    PostStatusV2.Failed,
    PostStatusV2.Posted,
  ])

  const selectionSet: Selection =
    selectedKeys === 'all' || !selectedKeys || selectedKeys.length === 0 ? 'all' : new Set(selectedKeys)

  const isSelected = selectionSet !== 'all'

  const handleChange = (status: 'all' | string) => {
    if (status === 'all') {
      onChange('all')
      return
    }

    if (selectedKeys && selectedKeys !== 'all') {
      if (selectedKeys.includes(status)) {
        const newSelection = selectedKeys.filter((key) => key !== status)
        onChange(newSelection.length > 0 ? newSelection : 'all')
      } else {
        onChange([...selectedKeys, status])
      }
    } else {
      onChange([status])
    }
  }

  return (
    <>
      <div className={Styles.header}>
        <IconButton icon={ArrowLeft} size="xs" variant="tertiary" onPress={onBack} data-testid="back-button" />
        <Text variant="secondary">Post Status</Text>
      </div>
      <div className={Styles.separator} />
      <Menu
        selectionMode="multiple"
        selectedKeys={isSelected ? selectionSet : []}
        onAction={(key) => handleChange(key as string)}
        itemClassName={Styles.menuItem}
        showCheckmark
      >
        {statusItems.map((status) => (
          <SelectableItem closeOnSelect={false} type="item" key={status}>
            <Tag
              size="md"
              color={STATUS_COLOR_FOR_STRATEGIES[status]}
              fontColor={STATUS_FONT_COLOR_FOR_STRATEGIES[status]}
            >
              {status}
            </Tag>
          </SelectableItem>
        ))}
      </Menu>
    </>
  )
}
